import baseMoment from 'moment';
import momentTZ from 'moment-timezone';

import 'moment/locale/ru';

export const getTimeZone = () => momentTZ().tz() || momentTZ.tz.guess();

export const setLocale = (locale: string) => {
  baseMoment.locale(locale);
  momentTZ.defineLocale(locale, baseMoment.localeData()['_config']);
  momentTZ.locale(locale);
};

export const setTimeZone = (zone: string) => momentTZ.tz.setDefault(zone);

export const formatDate = (date: Date | string, format: string) =>
  momentTZ(date).format(format);

export const now = () => moment();

export const resetTimeZone = (date: Date) =>
  new Date(momentTZ(date).format(UTC_FORMAT));

export const setBrowserTimeZone = (date: Date) => {
  const temp = momentTZ(date)
    .tz(momentTZ.tz.guess())
    .format(UTC_FORMAT);

  return new Date(momentTZ(temp).format());
};

const UTC_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const DATE_WITH_TIME_FORMAT = 'HH:mm:ss, DD.MM.YYYY';
export const DATE_WITH_SHORT_TIME_FORMAT = 'HH:mm, DD.MM.YYYY';
export const DATE_FORMAT = 'DD.MM.YYYY';
export const UTC_DATE_FORMAT = 'YYYY-MM-DD';

export const moment = momentTZ;
